import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Parses elemenst by element (DOM node) or by querySelector or  and assign
 * corresponding react component. Parameters in dataset are tried to convert
 * from JSON or else assumed to be string and passed to the component using name
 * conversion "data-prop-name" -> "prop-name".
 */

function byElement (element, Component, hydrate) {
  const props = {};
  for (const j in element.dataset) {
    let prop;
    try {
      prop = JSON.parse(element.dataset[j]);
    } catch(e) {
      prop = element.dataset[j];
    }
    props[j] = prop;
  }
  if(hydrate) {
    ReactDOM.hydrate(<Component {...props} />, element);
  } else {
    ReactDOM.render(<Component {...props} />, element);
  }
}

function byQuerySelector (querySelector, Component, hydrate) {
  if (hydrate === undefined) {
    hydrate = false;
  }
  const elements = document.querySelectorAll(querySelector)
  elements.forEach((element) => {
    byElement(element, Component, hydrate);
  });
}

export default {
  byElement,
  byQuerySelector,
}

